import type { DragEvent, KeyboardEvent } from 'react';

/** Toplantıyı klasöre sürükleme: kaynak kenar menü ve ana liste, hedef klasör satırı. */
const MEETING_TYPE = 'application/x-talknote-meeting';
const SAVED_ID = /^[0-9a-f-]{36}$/i;

/** Köprüde klasör yoksa (masaüstü) ya da toplantı henüz kaydedilmediyse sürüklenmez. */
export function meetingDragProps(meetingId: string) {
  if (!window.zabit.folders || !SAVED_ID.test(meetingId)) return {};
  return {
    draggable: true,
    onDragStart: (event: DragEvent) => {
      event.dataTransfer.setData(MEETING_TYPE, meetingId);
      event.dataTransfer.effectAllowed = 'move';
    },
  };
}

/**
 * Sürüklenen satır <button> olamıyor: Firefox düğmeleri sürüklemiyor. `div` düğme gibi
 * davransın diye klavye ve erişilebilirlik özellikleri buradan gelir.
 */
export function buttonRowProps(onActivate: () => void) {
  return {
    role: 'button',
    tabIndex: 0,
    onClick: onActivate,
    onKeyDown: (event: KeyboardEvent) => {
      if (event.key !== 'Enter' && event.key !== ' ') return;
      event.preventDefault();
      onActivate();
    },
  };
}

export const isMeetingDrag = (event: DragEvent) => event.dataTransfer.types.includes(MEETING_TYPE);

export const draggedMeetingId = (event: DragEvent) => event.dataTransfer.getData(MEETING_TYPE) || null;
